import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e4bd0bde")

_pushScopeId("data-v-e4bd0bde")
const _hoisted_1 = { class: "overlay create-report" }
const _hoisted_2 = { class: "create-report__text" }
const _hoisted_3 = { class: "create-report__body steps" }
const _hoisted_4 = { class: "steps-header" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "steps-header__line" }, null, -1)
const _hoisted_6 = { class: "row steps__body" }
const _hoisted_7 = { class: "col-12 col-lg-4" }
const _hoisted_8 = { class: "step-body step-body--active" }
const _hoisted_9 = { class: "step-body__title" }
const _hoisted_10 = { class: "step-body__text" }
const _hoisted_11 = { class: "step-body__control" }
const _hoisted_12 = { class: "col-12 col-lg-4" }
const _hoisted_13 = { class: "step-body__title" }
const _hoisted_14 = { class: "step-body__text" }
const _hoisted_15 = { class: "step-body__control" }
const _hoisted_16 = { class: "col-12 col-lg-4" }
const _hoisted_17 = { class: "step-body__title" }
const _hoisted_18 = { class: "step-body__text" }
const _hoisted_19 = { class: "step-body__control" }
const _hoisted_20 = {
  key: 0,
  id: "myModal",
  class: "modal"
}
const _hoisted_21 = { class: "modal-content modal-content__auth" }
const _hoisted_22 = { class: "modalcontent" }
const _hoisted_23 = { class: "modalcontent__h2" }
const _hoisted_24 = { class: "modalcontent__margin__auth" }
const _hoisted_25 = { class: "buttons" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_UiSearch = _resolveComponent("UiSearch")
  const _component_DropDownLoadFile = _resolveComponent("DropDownLoadFile")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('pages.home.createReportTitle')), 1),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode("div", {
          class: ["steps-header__num", { 'steps-header__num--active': $setup.step >= 0 }]
        }, " 1 ", 2),
        _createVNode("div", {
          class: ["steps-header__num", { 'steps-header__num--active': $setup.step >= 1 }]
        }, " 2 ", 2),
        _createVNode("div", {
          class: ["steps-header__num", { 'steps-header__num--active': $setup.step >= 2 }]
        }, " 3 ", 2)
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('labels.steps', [1])), 1),
            _createVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('labels.enterSearchData')), 1),
            _createVNode("div", _hoisted_11, [
              _createVNode(_component_UiSearch, {
                modelValue: $setup.bullSearchText,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ($setup.bullSearchText = $event)),
                options: $setup.bullOptions,
                placeholder: _ctx.$t('placeholders.enterName'),
                field: (opt) => opt.name,
                onSelect: $setup.selectBull,
                onFetch: $setup.fetchBulls
              }, null, 8, ["modelValue", "options", "placeholder", "field", "onSelect", "onFetch"])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_12, [
          _createVNode("div", {
            class: ["step-body", { 'step-body--active': $setup.step >= 1 }]
          }, [
            _createVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('labels.steps', [2])), 1),
            _createVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('labels.selectPeriod')), 1),
            _createVNode("div", _hoisted_15, [
              _createVNode(_component_UiSearch, {
                modelValue: $setup.bulletinPeriod,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ($setup.bulletinPeriod = $event)),
                options: $setup.bulletinPeriods,
                placeholder: _ctx.$t('placeholders.enterName'),
                field: 
                  (period) => {
                    return period.from_date + ' | ' + period.to_date
                  }
                ,
                icon: 'calendar',
                disabled: $setup.step === 0,
                onSelect: $setup.selectBullPeriod
              }, null, 8, ["modelValue", "options", "placeholder", "field", "disabled", "onSelect"])
            ])
          ], 2)
        ]),
        _createVNode("div", _hoisted_16, [
          _createVNode("div", {
            class: ["step-body", { 'step-body--active': $setup.step >= 2 }]
          }, [
            _createVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('labels.steps', [3])), 1),
            _createVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('labels.downloadReport')), 1),
            _createVNode("div", _hoisted_19, [
              _createVNode(_component_DropDownLoadFile, {
                class: "file-loader",
                disabled: !($setup.step >= 2),
                onSelect: $setup.selectFile
              }, null, 8, ["disabled", "onSelect"])
            ])
          ], 2)
        ])
      ])
    ]),
    _createVNode(_Transition, { name: "slide-fade" }, {
      default: _withId(() => [
        ($setup.changeactive1)
          ? (_openBlock(), _createBlock("div", _hoisted_20, [
              _createVNode("div", _hoisted_21, [
                _createVNode("span", {
                  class: "close",
                  onClick: _cache[3] || (_cache[3] = $event => ($setup.changeactive1 = !$setup.changeactive1))
                }, "×"),
                _createVNode("div", _hoisted_22, [
                  _createVNode("h2", _hoisted_23, _toDisplayString(_ctx.$t('message.authorized')), 1),
                  _createVNode("div", _hoisted_24, [
                    _createVNode("div", _hoisted_25, [
                      _createVNode("button", {
                        class: "button-using",
                        style: {"margin-right":"15px"},
                        onClick: _cache[4] || (_cache[4] = $event => ($setup.routerLink()))
                      }, _toDisplayString(_ctx.$t('profile.logIn')), 1),
                      _createVNode("button", {
                        onClick: _cache[5] || (_cache[5] = $event => ($setup.changeactive1 = !$setup.changeactive1)),
                        class: "\n                    button-create-new-report button-create-new-report__auth\n                  "
                      }, _toDisplayString(_ctx.$t('profile.cancel')), 1)
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
})